import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, finalize, take } from 'rxjs/operators';
//import { CookieService } from 'ngx-cookie-service';

import { environment } from '../../environments/environment';
import { Account, PhoneNumber, PhoneNumberOtp, PhoneNumbercheck, emailCheck } from '../_models';
import { UserData } from '../user/subuser-list/subuser-list.component';
//import { Variable } from '@angular/compiler/src/render3/r3_ast';

const baseUrl = `${environment.apiUrl}/accounts`;

@Injectable({ providedIn: 'root' })
export class AccountService {
    private accountSubject: BehaviorSubject<Account>;
    public account: Observable<Account>;

    constructor(
        private router: Router,
        private http: HttpClient,
        //private cookieService: CookieService,
    ) {
        const storedAccount = JSON.parse(localStorage.getItem('account'));
        this.accountSubject = new BehaviorSubject<Account>(storedAccount);
        this.account = this.accountSubject.asObservable();
    }

    public get accountValue(): Account {
        return this.accountSubject.value;
    }

    login(email: string, password: string) {
        return this.http.post<any>(`${baseUrl}/authenticate`, { email, password }, { withCredentials: true })
            .pipe(map(account => {
                console.log('account',account);
                localStorage.setItem('account', JSON.stringify(account));
                this.accountSubject.next(account);
                this.startRefreshTokenTimer();
                return account;
            }));
    }
    deleteCookie(name: string) {
        document.cookie = name;
      }
      logout() {
        // Call server to revoke refresh token (if needed)
        this.http.post<any>(`${baseUrl}/revoke-token`, {}, { withCredentials: true })
        .pipe(take(1))
        .subscribe({
          next: () => console.log('Token successfully revoked.'),
          error: err => console.error('Error revoking token:', err)
        });
      
        // Stop token timer and clear stored data
        this.stopRefreshTokenTimer();
        this.accountSubject.next(null);
      
        // Clear local storage (in case you store token/account here)
        localStorage.removeItem('account');
        localStorage.removeItem('refreshToken');
      
        // Redirect to login
        this.router.navigate(['/account/login']);
      }
      

    refreshToken() {
        return this.http.post<any>(`${baseUrl}/refresh-token`, {}, { withCredentials: true })
            .pipe(map((account) => {
                localStorage.setItem('account', JSON.stringify(account));
                this.accountSubject.next(account);
                this.startRefreshTokenTimer();
                return account;
            }));
    }

    register(account: Account) {
        return this.http.post(`${baseUrl}/register`, account);
    }
    verifyphone(phone: PhoneNumber) {
        return this.http.post(`${baseUrl}/getOTP`, phone);
    }
    phonecheck(phone: PhoneNumbercheck) {
        return this.http.post(`${baseUrl}/phonecheck`, phone);
    }
    verifyOtp(phone: PhoneNumberOtp) {
        return this.http.post(`${baseUrl}/verify-phone`, phone);
    }

    verifyEmail(token: string) {
        return this.http.post(`${baseUrl}/verify-email`, { token });
    }
    emailCheck(email: emailCheck) {
        console.log(email);
        return this.http.post(`${baseUrl}/emailcheck`, { email });
    }
    getaccountbycompanyid(accountid: any): Observable<UserData[]> {
        return this.http.post<UserData[]>(`${baseUrl}/getaccountbycompanyid`, { companyid: accountid });
    }
    
    forgotPassword(email: string) {
        return this.http.post(`${baseUrl}/forgot-password`, { email });
    }
    
    validateResetToken(token: string) {
        return this.http.post(`${baseUrl}/validate-reset-token`, { token });
    }
    
    resetPassword(token: string, password: string, confirmPassword: string) {
        return this.http.post(`${baseUrl}/reset-password`, { token, password, confirmPassword });
    }

    getAll() {
        return this.http.get<Account[]>(baseUrl);
    }

    getById(id: string) {
        return this.http.get<Account>(`${baseUrl}/${id}`);
    }
    
    create(params) {
        return this.http.post(baseUrl, params);
    }
    
    update(id, params) {
        return this.http.put(`${baseUrl}/${id}`, params)
            .pipe(map((account: any) => {
                // update the current account if it was updated
                if (account.id === this.accountValue.id) {
                    // publish updated account to subscribers
                    account = { ...this.accountValue, ...account };
                    this.accountSubject.next(account);
                }
                return account;
            }));
    }
    
    delete(id: string) {
        return this.http.delete(`${baseUrl}/${id}`)
            .pipe(finalize(() => {
                // auto logout if the logged in account was deleted
                if (id === this.accountValue.id)
                    this.logout();
            }));
    }

    // helper methods

    private refreshTokenTimeout;

    private startRefreshTokenTimer() {
        // parse json object from base64 encoded jwt token
        const jwtToken = JSON.parse(atob(this.accountValue.jwtToken.split('.')[1]));

        // set a timeout to refresh the token a minute before it expires
        const expires = new Date(jwtToken.exp * 1000);
        const timeout = expires.getTime() - Date.now() - (60 * 1000);
        this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
    }

    private stopRefreshTokenTimer() {
        clearTimeout(this.refreshTokenTimeout);
    }

    uploadUserProfilePic(accountId:any, file:any){
        const formData = new FormData();
        formData.append('file', file);  
        return this.http.post(`${baseUrl}/profilepic?accountid=${accountId}`, formData);
      }
}